import { NgModule }       from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

import { BetaWarningModule }   from './beta-warning/beta-warning.module';
import { ConfirmModule }       from './confirm/confirm.module';
import { MessagesComponent }   from './messages.component';
import { MessagesService }     from '../messages/messages.service';
import { MessengerModule }     from './messenger/messenger.module';
import { NotificationsModule } from './notifications/notifications.module';
import { SharedModule }        from '../shared/shared.module';

@NgModule({
  declarations: [
    MessagesComponent
  ],
  entryComponents: [
    MessagesComponent
  ],
  exports: [
    BetaWarningModule,
    ConfirmModule,
    MessengerModule,
    NotificationsModule
  ],
  imports: [
    // Third Party
    NgbToastModule,

    // Custom
    BetaWarningModule,
    ConfirmModule,
    MessengerModule,
    NotificationsModule,
    SharedModule
  ],
  providers: [
    MessagesService
  ]
})
export class MessagesModule {}
